const StaticApiHeader = Object.freeze({
    CONTENT_TYPE: "application/json",
    ACCEPT: "application/json",
    X_CLIENT_ID: "12345",
    // X-Api-Key 는 환경변수 REACT_APP_API_KEY 사용. CommonApi.ts 참조.
    QA_X_SERVICE_CODE: "CHN000113",
    PROD_X_SERVICE_CODE: "CHN000037",
    QA_X_SERVICE_PHASE: "QA",
    X_API_VERSION: 3.2,
    X_THINQ_CLIENT_TYPE: "MANAGER",
    X_THINQ_CLIENT_VERSION: 0.1,
    X_THINQ_APP_VER: 3.2,
    QA_X_THINQ_APP_LEVEL: "DEV",
});

export default StaticApiHeader;
